import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import groupTravelPhoto from "./../../assets/group-travel-photo.jpg";
import LayoutWrapperHOC from "../layout.wrapper.hoc";
import { LayoutCodes } from "../../utils/enums/LayoutCodes";
var OnboardingLayout = function (_a) {
    var children = _a.children;
    return (_jsx(_Fragment, { children: _jsx(Outlet, {}) }));
};
export default LayoutWrapperHOC(OnboardingLayout, {
    layoutType: LayoutCodes.ONBOARDING,
    backgroundImage: groupTravelPhoto,
});
